import { WorldTourSeasonRecord } from "model/Records old/WorldTourSeasonRecord";
import { selectRosterDisplayName } from "selectors/Roster";
import {
  PositionCell,
  RecordCell,
  OrgLogoCell,
  OrgLogoContainer,
  OrgNameCell,
  TeamRow,
  DifferentialCell,
  WinLossRecordCell,
} from "../../styles";
import { RosterOrgLogo } from "components/Logo/RosterOrgLogo";
import { useAppSelector } from "app/hooks";

interface Props {
  record: WorldTourSeasonRecord;
  tournamentId: string;
}

export const SetSeasonTableRow = ({ record, tournamentId }: Props) => {
  const displayName = useAppSelector((state) =>
    selectRosterDisplayName(state, record.rosterId, tournamentId)
  );

  const trackDifferential = record.tracksWon - record.tracksLost;
  const roundDifferential = record.roundPointsFor - record.roundPointsAgainst;

  return (
    <TeamRow>
      <PositionCell>{record.position}.</PositionCell>
      <OrgLogoCell>
        <OrgLogoContainer>
          <RosterOrgLogo
            rosterId={record.rosterId}
            tournamentId={tournamentId}
          />
        </OrgLogoContainer>
      </OrgLogoCell>
      <OrgNameCell>{displayName}</OrgNameCell>
      <WinLossRecordCell>
        {record.wins} - {record.loses}
      </WinLossRecordCell>
      <RecordCell>
        {record.tracksWon} - {record.tracksLost}
      </RecordCell>
      <DifferentialCell>
        {trackDifferential > 0 ? "+" : ""}
        {trackDifferential}
      </DifferentialCell>
      <RecordCell>
        {record.roundPointsFor} - {record.roundPointsAgainst}
      </RecordCell>
      <DifferentialCell>
        {roundDifferential > 0 ? "+" : ""}
        {roundDifferential}
      </DifferentialCell>
    </TeamRow>
  );
};
